// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1sIU_","info":"PatientInfo_info__2I_Gl"};